import { serverTimestamp } from 'firebase/firestore';

import { InputBase } from '../types/entity-input';

export const createTimestamps = (): InputBase => ({
  createdAt: serverTimestamp(),
  updatedAt: serverTimestamp()
});
